import { FC } from 'react'
import styled from 'styled-components'
import ColorProofIndicator from '../../../../../components/color-proof-indicator/color-proof-indicator'
import Preparation from './preparation/preparation'
import PrintStatus from './print-status'
import { DataSourceItem } from '../../../shipments-page'

interface StatusProps {
    data: DataSourceItem
}

const Status: FC<StatusProps> = ({ data }) => {
    const tasks = data.tasks || []
    const hasPreparationTasks = tasks.length > 0
    const hasBlankPreviewFiles = Boolean(data.blankPreviewFiles?.length)
    const printJob = data.print_job
    const isColorProof = data.shipmentType === 'colorProof'

    if (!hasPreparationTasks && !hasBlankPreviewFiles && !printJob && !isColorProof) {
        return null
    }

    return (
        <StatusCell>
            <Preparation data={data} />
            {printJob && <PrintStatus printJob={printJob} />}
            {isColorProof && <ColorProofIndicator />}
        </StatusCell>
    )
}

const StatusCell = styled.span`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
    padding-top: 2px;
`

export default Status
